import Url from 'url-parse';

export class WebsiteCookies {
  setCookie(name, value, days) {
    let expires;
    // let domain = `.${process.env.NEXT_PUBLIC_DOMAIN_NAME}`;
    let domain  =   `.${Url(process.env.NEXTAUTH_URL).hostname}`
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
      domain = '; domain=' + domain;
    }
    document.cookie = name + '=' + (value || '') + expires + domain + '; path=/';
  }

  getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  deleteAllCookies() {
    var cookies = document.cookie.split(";");
    // let domain = `.${process.env.NEXT_PUBLIC_DOMAIN_NAME}`;
    let domain  =   `.${Url(process.env.NEXTAUTH_URL).hostname}`

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }

    document.cookie = `userType=;domain=${domain};path=/;max-age=0`;
  }

}
